var _excluded = ["inline", "label", "label2", "value", "value2", "minValue", "maxValue", "readOnlyStart", "readOnlyEnd", "onTimesChange", "mountNode"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { convertTimeToSec } from "../../utils";
import Time from "./Time";

/**
* @deprecated  This component is deprecated and will be removed in next major release.
*              Veuillez utiliser SingleDatePicker ou DateRangePicker à la place.
*/
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TimeRange = function TimeRange(props) {
  var inline = props.inline,
    label = props.label,
    label2 = props.label2,
    value = props.value,
    value2 = props.value2,
    minValue = props.minValue,
    maxValue = props.maxValue,
    readOnlyStart = props.readOnlyStart,
    readOnlyEnd = props.readOnlyEnd,
    onTimesChange = props.onTimesChange,
    mountNode = props.mountNode,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _React$useState = React.useState(convertTimeToSec(value) > convertTimeToSec(minValue) ? value : minValue),
    minEndValueState = _React$useState[0],
    setMinEndValueState = _React$useState[1];
  var _React$useState2 = React.useState(maxValue),
    maxEndValueState = _React$useState2[0];
  var _React$useState3 = React.useState(minValue),
    minStartValueState = _React$useState3[0];
  var _React$useState4 = React.useState(convertTimeToSec(value2) < convertTimeToSec(maxValue) ? value2 : maxValue),
    maxStartValueState = _React$useState4[0],
    setMaxStartValueState = _React$useState4[1];
  var _React$useState5 = React.useState(value),
    localValue = _React$useState5[0],
    setLocalValue = _React$useState5[1];
  var _React$useState6 = React.useState(value2),
    localValue2 = _React$useState6[0],
    setLocalValue2 = _React$useState6[1];
  useEffect(function () {
    setLocalValue(value);
    setLocalValue2(value2);
  }, [value, value2]);
  var handleChangeStart = React.useCallback(function (event, data) {
    var _ref = data || {},
      val = _ref.value;
    setLocalValue(val);
    if (val !== '00:00') {
      setMinEndValueState(val);
      if (onTimesChange) {
        onTimesChange({
          startTime: val,
          endTime: localValue2
        });
      }
    } else {
      setMinEndValueState(minValue);
    }
  }, [localValue2, minValue, onTimesChange]);
  var handleChangeEnd = React.useCallback(function (event, data) {
    var _ref2 = data || {},
      val = _ref2.value;
    setLocalValue2(val);
    if (val !== '00:00') {
      setMaxStartValueState(val);
      if (onTimesChange) {
        onTimesChange({
          startTime: localValue,
          endTime: val
        });
      }
    } else {
      setMaxStartValueState(maxValue);
    }
  }, [localValue, maxValue, onTimesChange]);
  var handleErrorStart = React.useCallback(function () {
    setMinEndValueState(minValue);
    setLocalValue('error');
    if (onTimesChange) {
      onTimesChange({
        startTime: 'error',
        endTime: localValue2
      });
    }
  }, [minValue, onTimesChange, localValue2]);
  var handleErrorEnd = React.useCallback(function () {
    setMaxStartValueState(maxValue);
    setLocalValue2('error');
    onTimesChange({
      startTime: localValue,
      endTime: 'error'
    });
  }, [maxValue, onTimesChange, localValue]);
  return React.useMemo(function () {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        display: 'inline-flex',
        alignItems: 'flex-end'
      },
      children: [/*#__PURE__*/_jsx(Time, Object.assign({
        label: label,
        value: value,
        minValue: minStartValueState,
        maxValue: maxStartValueState,
        defaultMinValue: minValue,
        defaultMaxValue: maxValue,
        onTimeChange: handleChangeStart,
        onError: handleErrorStart,
        timeRange: true,
        mountNode: mountNode,
        startTime: true,
        readOnly: readOnlyStart
      }, rest)), /*#__PURE__*/_jsx("div", {
        style: {
          width: '25px',
          height: '38px',
          lineHeight: '38px',
          textAlign: 'center'
        },
        children: "-"
      }), /*#__PURE__*/_jsx(Time, Object.assign({
        label: label2,
        value: value2,
        minValue: minEndValueState,
        maxValue: maxEndValueState,
        defaultMinValue: minValue,
        defaultMaxValue: maxValue,
        onTimeChange: handleChangeEnd,
        onError: handleErrorEnd,
        timeRange: true,
        mountNode: mountNode,
        startTime: false,
        readOnly: readOnlyEnd
      }, rest))]
    });
  }, [label, value, minStartValueState, maxStartValueState, minValue, maxValue, handleChangeStart, handleErrorStart, mountNode, rest, label2, value2, minEndValueState, maxEndValueState, handleChangeEnd, handleErrorEnd]);
};
TimeRange.handledProps = ["inline", "label", "label2", "maxValue", "minValue", "mountNode", "value", "value2"];
TimeRange.propTypes = {
  inline: PropTypes.bool,
  label: PropTypes.string,
  label2: PropTypes.string,
  value: PropTypes.string,
  value2: PropTypes.string,
  minValue: PropTypes.string,
  maxValue: PropTypes.string,
  mountNode: PropTypes.node
};
TimeRange.defaultProps = {
  inline: true,
  label: '',
  label2: '',
  value: '',
  value2: '',
  minValue: '00:00',
  maxValue: '23:59'
};
export default TimeRange;